import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

const CARD_SKELETON_COUNT = 6

export function CampaignListPageSkeleton() {
  return (
    <Box
      data-testid="campaign-list-skeleton"
      aria-busy="true"
      aria-label="Loading campaigns"
      sx={{ position: 'relative' }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
        <Box>
          <Skeleton variant="text" width={180} height={32} />
          <Skeleton variant="text" width={320} height={20} sx={{ mt: '4px' }} />
        </Box>
        <Box sx={{ display: 'flex', gap: '12px' }}>
          <Skeleton variant="rounded" width={225} height={42} sx={{ borderRadius: '10px' }} />
          <Skeleton variant="rounded" width={180} height={40} sx={{ borderRadius: '8px' }} />
        </Box>
      </Box>
      <Box
        sx={{
          mt: '32px',
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, minmax(0, 1fr))',
            lg: 'repeat(3, minmax(0, 1fr))',
          },
          gap: '32px',
        }}
      >
        {Array.from({ length: CARD_SKELETON_COUNT }, (_, index) => (
          <Skeleton key={index} variant="rounded" height={292} sx={{ borderRadius: '10px' }} />
        ))}
      </Box>
    </Box>
  )
}
